var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSettings16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    mlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24654 1.28838C8.81246 -0.429459 6.37179 -0.429459 5.93771 1.28838C5.67718 2.31944 4.5472 2.86357 3.57864 2.42442C1.96496 1.69273 0.44323 3.60094 1.51562 5.01134C2.15929 5.85789 1.88024 7.08061 0.932976 7.56407C-0.64518 8.36955 -0.102059 10.749 1.66927 10.79C2.73248 10.8145 3.51443 11.7951 3.30178 12.8371C2.94756 14.5731 5.14651 15.6321 6.28295 14.2727C6.96505 13.4568 8.2192 13.4568 8.9013 14.2727C10.0377 15.6321 12.2367 14.5731 11.8825 12.8371C11.6698 11.7951 12.4518 10.8145 13.515 10.79C15.2863 10.749 15.8294 8.36955 14.2513 7.56407C13.304 7.08061 13.025 5.85789 13.6686 5.01134C14.741 3.60094 13.2193 1.69273 11.6056 2.42442C10.637 2.86357 9.50707 2.31944 9.24654 1.28838ZM7.59212 10.7411C9.24899 10.7411 10.5921 9.39799 10.5921 7.74113C10.5921 6.08427 9.24899 4.74113 7.59212 4.74113C5.93526 4.74113 4.59212 6.08427 4.59212 7.74113C4.59212 9.39799 5.93526 10.7411 7.59212 10.7411Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;